// extracted by mini-css-extract-plugin
module.exports = {"modal":"SpreadModal_style_modal__1b8te"};